"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "52", height: "56", viewBox: "0 0 52 56", className: "Icon payment-individual", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#F4511C", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M2.331 46.321v6.238A1.44 1.44 0 0 0 3.771 54H49.01a1.44 1.44 0 0 0 1.44-1.441V46.32c0-5.279-5.052-16.545-24.059-16.545-19.006 0-24.059 11.266-24.059 16.545zm-1.5 0c0-3.644 1.862-7.99 5.366-11.337 4.472-4.271 11.205-6.708 20.193-6.708 8.989 0 15.722 2.437 20.193 6.708 3.504 3.348 5.366 7.693 5.366 11.337v6.238a2.94 2.94 0 0 1-2.94 2.941H3.772a2.94 2.94 0 0 1-2.94-2.941V46.32zM26.39 23.532c5.906 0 10.693-4.82 10.693-10.766S32.296 2 26.39 2c-5.905 0-10.692 4.82-10.692 10.766s4.787 10.766 10.692 10.766zm0 1.5c-6.736 0-12.192-5.494-12.192-12.266S19.654.5 26.39.5c6.737 0 12.193 5.494 12.193 12.266S33.127 25.032 26.39 25.032z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/payment-individual.js
// module id = 1822
// module chunks = 0